<form [formGroup]="formName">
    <mat-form-field appearance="outline" >
        <mat-label>{{field.label}}</mat-label>
        <input matInput [type]="field.type" [formControlName]="field.fieldName" [placeholder]="field.placeholder" [readonly]="field.readonly ? field.readonly : false"
        *ngIf="field.type != 'password' && field.type != 'price'"
        >
        <mat-icon matSuffix *ngIf="getFieldName.errors && getFieldName.touched && field.type != 'password'"
            style="color: #da5757">report</mat-icon>

        <mat-hint *ngIf="field.type != 'password'">
            <p *ngIf="getFieldName.errors?.required && getFieldName.touched" style="color: #da5757">El campo no puede ir vacío ó no es valido</p>
            <p *ngIf="getFieldName.errors?.minlength && getFieldName.touched" style="color: #da5757">El campo debe ser mayor a {{field.rules.min}} carácteres</p>
            <p *ngIf="getFieldName.errors?.maxlength && getFieldName.touched" style="color: #da5757">El campo no debe ser mayor a {{field.rules.max}} carácteres</p>
            <p *ngIf="(getFieldName.errors?.validate || getFieldName.errors?.email ) 
                    && !getFieldName.errors?.required
                    && !getFieldName.errors?.minlength
                    && !getFieldName.errors?.maxlength
                " 
                style="color: #da5757">El campo es inválido</p>
        </mat-hint>


        <input matInput type="password" [formControlName]="field.fieldName" [placeholder]="field.placeholder" [readonly]="field.readonly ? field.readonly : false"
            *ngIf="field.type == 'password'"
            [type]="field.hide ? 'password' : 'text'" autocomplete="off"  />
        <button type="button" mat-icon-button matSuffix (click)="field.hide = !field.hide"
            [attr.aria-label]="'Hide password'" [attr.aria-pressed]="field.hide" *ngIf="field.type == 'password'">
            <mat-icon>{{ field.hide ? 'visibility_off' : 'visibility' }}</mat-icon>
        </button>

        <input matInput type="number" [formControlName]="field.fieldName" [placeholder]="field.placeholder" [readonly]="field.readonly ? field.readonly : false"
        *ngIf="field.type == 'price'"
        >
        <span matPrefix *ngIf="field.type == 'price'">$&nbsp;</span>
        
        <!-- <mat-hint *ngIf="formName.controls[field.fieldName].errors?.minlength" style="color: #da5757">El campo debe ser mayor a {{field.rules.min}} carácteres</mat-hint> -->
        <!-- <mat-hint *ngIf="formName.controls[field.fieldName].errors?.maxlength" style="color: #da5757">El campo no debe ser mayor a {{field.rules.max}} carácteres</mat-hint> -->
    </mat-form-field>
</form>
